// Modules
import { createApi } from '@reduxjs/toolkit/query/react';
import { endpoints } from 'config/api';
import { axiosBaseQueryFactory } from 'config/axiosBaseQuery';

// Utils
import {
  StartOnboardingDto,
  StartOnboardingResponse,
} from './onboardingTypes';

export const onboardingApi = createApi({
  reducerPath: 'onboardingApi',
  baseQuery: axiosBaseQueryFactory({ isPublic: true }),
  endpoints: (builder) => ({
    startOnboarding: builder.mutation<StartOnboardingResponse, StartOnboardingDto>({
      query: (userData) => ({
        url: endpoints.onboarding.base,
        method: 'POST',
        data: userData,
      }),
    }),
  }),
});

export const {
  useStartOnboardingMutation,
} = onboardingApi;
